import React, { useCallback } from 'react';
import { useObservable } from 'react-use-observable';

import { Row, Col, Button } from 'antd';

import refundService from 'v2/services/requestManagement/refund';

const RefundSelect = () => {
  const [list] = useObservable(() => refundService.list(), []);

  const onUnCheckAll = useCallback(() => refundService.unCheckAllRefunds(), []);

  const selected = (list || []).filter(r => r.checked);

  const quantity = selected?.length;

  const onClickAprove = useCallback(() => refundService.openMassApprove(), []);

  if (!quantity) return null;

  return (
    <Col span={24}>
      <div className='w-full transition-opacity duration-300'>
        <Row justify='space-between' align='middle'>
          <Col md={12} xs={24}>
            <p className='text-base'>{quantity} solicitações selecionadas</p>
          </Col>
          <Col md={12} xs={24}>
            <div className='flex justify-end gap-2'>
              <Button onClick={onUnCheckAll}>Limpar seleção</Button>
              <Button type='primary' onClick={onClickAprove}>
                Reembolsar selecionados ({quantity})
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </Col>
  );
};
export default RefundSelect;
